import { escapeHtml } from './helpers';

/**
 * Client-side inspiration card renderer for Elastic listing results.
 * Canonical PHP markup lives in template-parts/cards/card-inspiration.php (SSR).
 */
export const getInspirationGalleryItemLayout = index => {
    const group = index % 5;
    let imgClass = 'w-full object-cover rounded-small rounded-small';
    let colClass = 'desktop:col-span-6';

    switch (group) {
        case 0:
            imgClass += ' desktop:aspect-[5/4]';
            colClass = 'desktop:col-span-7';
            break;
        case 1:
            imgClass += ' desktop:aspect-[16/9]';
            colClass = 'desktop:col-span-5';
            break;
        case 2:
            imgClass += ' desktop:aspect-[4/5]';
            colClass = 'desktop:col-span-4';
            break;
        case 3:
            imgClass += ' desktop:aspect-[5/4]';
            colClass = 'desktop:col-span-3';
            break;
        case 4:
            imgClass += ' desktop:aspect-[4/5]';
            colClass = 'desktop:col-span-5';
            break;
        default:
            break;
    }

    return { colClass, imgClass };
};

export const resolveInspirationItemImage = (item = {}) => {
    const attachmentId = Number(item.attachment_id || 0);
    const inspiration = item.inspiration || {};
    const thumbnail = inspiration.thumbnail || {};
    const gallery = Array.isArray(inspiration.gallery) ? inspiration.gallery : [];

    if (
        Number(thumbnail.attachment_id || 0) === attachmentId &&
        thumbnail.url
    ) {
        return {
            url: String(thumbnail.url),
            alt: String(thumbnail.alt || inspiration.name || ''),
        };
    }

    const galleryMatch = gallery.find(
        entry => Number(entry?.attachment_id || 0) === attachmentId && entry?.url
    );

    if (galleryMatch) {
        return {
            url: String(galleryMatch.url),
            alt: String(galleryMatch.alt || inspiration.name || ''),
        };
    }

    if (thumbnail.url) {
        return {
            url: String(thumbnail.url),
            alt: String(thumbnail.alt || inspiration.name || ''),
        };
    }

    return { url: '', alt: '' };
};

export const renderInspirationCardFromElastic = (item, options = {}) => {
    const termId = Number(item?.term_id || 0);
    const attachmentId = Number(item?.attachment_id || 0);
    const gridIndex = Number(item?.grid_index || 0);
    const id = `${termId}:${attachmentId}`;
    const openLabel = escapeHtml(
        options.openLabel || 'Zobacz inspirację'
    );

    if (termId <= 0 || attachmentId <= 0) {
        return { id, html: '' };
    }

    const { colClass, imgClass } = getInspirationGalleryItemLayout(gridIndex);
    const { url, alt } = resolveInspirationItemImage(item);
    const imageMarkup =
        url !== ''
            ? `<img class="${imgClass}" src="${escapeHtml(url)}" alt="${escapeHtml(alt)}">`
            : '';

    const html = `<div class="col-span-2 ${colClass} group relative" data-term-id="${termId}" data-attachment-id="${attachmentId}" data-active="1" js-gallery-item js-inspiration-card>${imageMarkup}<button type="button" class="absolute top-16 right-16 z-10 flex h-[40px]! w-[41.6px]! items-center justify-center rounded-full bg-orange-500 text-grey-900 transition-opacity desktop:opacity-0 desktop:group-hover:opacity-100" data-inspiration-open aria-label="${openLabel}"><i class="icon icon-arrow-right text-[18px]!" aria-hidden="true"></i></button></div>`;

    return { id, html };
};
